document.documentElement.classList.add('js');
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav.toggleAttribute('data-open');
    trigger.setAttribute('aria-expanded', String(open));
  }
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-photo-input]')) {
    const file = event.target.files && event.target.files[0];
    const box = event.target.closest('[data-personalization]');
    const preview = box && box.querySelector('[data-photo-preview]');
    if (!file || !preview) return;
    preview.querySelector('img').src = URL.createObjectURL(file);
    preview.querySelector('[data-photo-name]').textContent = file.name;
    preview.hidden = false;
    return;
  }
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  if (form && option) form.querySelector('[name="id"]').value = option.value;
  const price = document.querySelector('[data-product-price]');
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
});
